<template>
  <b-overlay :show="loading">
    <b-card-actions action-collapse title="Setting Marketing">
      <p class="mb-2 text-body">
        Tempatkan sales ke mobil sebagai lokasi stok jualan.
      </p>

      <b-row class="align-items-end mb-1">
        <b-col md="3" sm="6" class="my-1">
          <b-form-group label="Per halaman" label-for="perPageSelect" class="mb-0">
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="5" sm="6" class="my-1">
          <b-form-group label="Cari" label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Cari data setting marketing..."
                @keyup.enter="applySearch"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="clearSearch">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12" class="my-1 d-flex justify-content-md-end">
          <b-button
            v-if="allowCreate()"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-b-modal.modal-tambah
            variant="primary"
            @click="add"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Tambah
          </b-button>
        </b-col>
      </b-row>

      <!-- Modal Tambah / Edit (satu modal, dipakai create & update) -->
      <b-modal
        v-if="allowCreate() || allowUpdate()"
        id="modal-tambah"
        v-model="showModal"
        cancel-variant="secondary"
        centered
        :title="id ? 'Form Ubah' : 'Form Tambah'"
        hide-footer
      >
        <b-form>
          <b-form-group label="Teritori" label-for="teritory">
            <v-select
              id="teritory"
              v-model="form.teritory_id"
              :options="teritory_id"
              :reduce="(option) => option.value"
              label="text"
              placeholder="Pilih teritori..."
            />
          </b-form-group>
          <b-form-group label="Rute" label-for="rute">
            <v-select
              id="rute"
              v-model="selectedRutes"
              :options="rutes"
              multiple
              label="text"
              placeholder="Pilih rute..."
            />
          </b-form-group>
          <b-form-group label="Kendaraan" label-for="kendaraan">
            <v-select
              id="kendaraan"
              v-model="form.kendaraan_id"
              :options="kendaraan_id"
              :reduce="(option) => option.value"
              label="text"
              placeholder="Pilih kendaraan..."
            />
          </b-form-group>
          <b-form-group label="Sales" label-for="sales">
            <v-select
              id="sales"
              v-model="form.karyawan_id"
              :options="karyawan_id"
              :reduce="(option) => option.value"
              label="text"
              placeholder="Pilih sales..."
            />
            <strong v-if="isAllSalesOut" class="d-block text-danger">
              <i>Semua sales sudah ditempatkan</i>
            </strong>
          </b-form-group>
          <b-form-group label="Driver" label-for="driver">
            <v-select
              id="driver"
              v-model="form.driver_id"
              :options="driver_id"
              :reduce="(option) => option.value"
              label="text"
              placeholder="Pilih driver..."
            />
          </b-form-group>
          <b-form-group label="Alamat (Opsional)" label-for="alamat">
            <b-form-textarea
              id="alamat"
              v-model="form.alamat"
              placeholder="Isi Alamat"
            />
          </b-form-group>
          <b-form-group label="Keterangan (Opsional)" label-for="keterangan">
            <b-form-textarea
              id="keterangan"
              v-model="form.keterangan"
              placeholder="Isi Keterangan"
            />
          </b-form-group>
        </b-form>

        <div class="d-flex justify-content-end align-items-center mt-2">
          <b-button
            size="sm"
            class="mr-1"
            variant="outline-secondary"
            :disabled="saving"
            @click="showModal = false"
          >
            Batal
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            :disabled="saving"
            @click="submit"
          >
            <b-spinner v-if="saving" small class="mr-50" />
            {{ saving ? "Menyimpan..." : id ? "Ubah" : "Simpan" }}
          </b-button>
        </div>
      </b-modal>

      <!-- Modal ubah legacy (tetap ada jika dibuka via showModalEdit) -->
      <b-modal
        v-if="allowUpdate()"
        id="modal-ubah"
        v-model="showModalEdit"
        cancel-variant="secondary"
        centered
        title="Form Ubah"
        hide-footer
      >
        <b-form>
          <b-form-group label="Teritori" label-for="teritory-edit">
            <v-select
              id="teritory-edit"
              v-model="form.teritory_id"
              :options="teritory_id"
              :reduce="(option) => option.value"
              label="text"
              placeholder="Pilih teritori..."
            />
          </b-form-group>
          <b-form-group label="Kendaraan" label-for="kendaraan-edit">
            <v-select
              id="kendaraan-edit"
              v-model="form.kendaraan_id"
              :options="kendaraan_id"
              :reduce="(option) => option.value"
              label="text"
              placeholder="Pilih kendaraan..."
            />
          </b-form-group>
          <b-form-group label="Sales" label-for="sales-edit">
            <v-select
              id="sales-edit"
              v-model="form.karyawan_id"
              :options="karyawan_id"
              :reduce="(option) => option.value"
              label="text"
              placeholder="Pilih sales..."
            />
          </b-form-group>
          <b-form-group label="Driver" label-for="driver-edit">
            <v-select
              id="driver-edit"
              v-model="form.driver_id"
              :options="driver_id"
              :reduce="(option) => option.value"
              label="text"
              placeholder="Pilih driver..."
            />
          </b-form-group>
          <b-form-group label="Alamat (Opsional)" label-for="alamat-edit">
            <b-form-textarea
              id="alamat-edit"
              v-model="form.alamat"
              placeholder="Isi Alamat"
            />
          </b-form-group>
          <b-form-group label="Keterangan (Opsional)" label-for="keterangan-edit">
            <b-form-textarea
              id="keterangan-edit"
              v-model="form.keterangan"
              placeholder="Isi Keterangan"
            />
          </b-form-group>
        </b-form>
        <div class="d-flex justify-content-end align-items-center mt-2">
          <b-button
            size="sm"
            class="mr-1"
            variant="outline-secondary"
            :disabled="saving"
            @click="showModalEdit = false"
          >
            Batal
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            :disabled="saving"
            @click="submit"
          >
            <b-spinner v-if="saving" small class="mr-50" />
            {{ saving ? "Menyimpan..." : "Ubah" }}
          </b-button>
        </div>
      </b-modal>

      <b-row>
        <b-col cols="12">
          <div
            v-if="!loading && !items.length"
            class="text-center text-muted py-4 border rounded"
          >
            Belum ada data setting marketing
            <span v-if="filter"> untuk pencarian “{{ filter }}”</span>.
          </div>
          <b-table
            v-else
            striped
            small
            hover
            responsive
            :items="items"
            :fields="fields"
            show-empty
            empty-text="Tidak ada data"
          >
            <template #cell(no)="row">
              <strong>
                {{ (currentPage - 1) * perPage + row.index + 1 }}
              </strong>
            </template>

            <template #cell(teritori)="{ item }">
              <div>
                <strong>
                  {{ item.teritori && item.teritori.nama_teritori
                    ? item.teritori.nama_teritori
                    : "-" }}
                </strong>
                <small class="d-block text-muted">
                  Kendaraan:
                  {{
                    item.kendaraan
                      ? [
                          item.kendaraan.nama_kendaraan,
                          item.kendaraan.plat_nomer,
                        ]
                          .filter(Boolean)
                          .join(" · ") || "-"
                      : "-"
                  }}
                </small>
              </div>
            </template>

            <template #cell(info_sales)="{ item }">
              <div>
                <strong>
                  {{ item.karyawan && item.karyawan.nama_lengkap
                    ? item.karyawan.nama_lengkap
                    : "-" }}
                </strong>
                <small class="d-block text-muted">
                  Driver:
                  {{
                    item.driver && item.driver.nama_lengkap
                      ? item.driver.nama_lengkap
                      : "-"
                  }}
                </small>
              </div>
            </template>

            <template #cell(rute_sales)="{ item }">
              <ul
                v-if="item.rute_sales && item.rute_sales.length"
                class="mb-0 pl-1"
              >
                <li
                  v-for="(rute, idx) in item.rute_sales"
                  :key="`${item.id}-rute-${idx}`"
                >
                  {{ rute }}
                </li>
              </ul>
              <span v-else>-</span>
            </template>

            <template #cell(keterangan)="{ item }">
              {{ item.keterangan || "-" }}
            </template>

            <template #cell(actions)="row">
              <b-button
                v-if="allowUpdate()"
                v-b-tooltip.hover.right="'Ubah'"
                size="sm"
                class="mr-50"
                variant="outline-info"
                @click="edit(row.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                v-if="allowDelete()"
                v-b-tooltip.hover.right="'Hapus'"
                size="sm"
                variant="outline-danger"
                @click="remove(row.item)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12" class="d-flex justify-content-between align-items-center mt-1">
          <small class="text-muted">
            Total {{ totalRows }} data
          </small>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card-actions>
  </b-overlay>
</template>

<script>
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BTable,
  BOverlay,
  VBTooltip,
  BModal,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormTextarea,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    BCardActions,
    ToastificationContent,
    BModal,
    BFormTextarea,
    BTable,
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BForm,
    BInputGroupAppend,
    BButton,
    BSpinner,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      isAllSalesOut: false,
      showModalEdit: false,
      showModal: false,
      id: null,
      activeAction: "tambah",
      myRutes: [],
      selectedRutes: [],
      form: {
        nama_gudang: "-",
        teritory_id: 0,
        jenis: 2,
        kendaraan_id: null,
        karyawan_id: null,
        driver_id: null,
        keterangan: "",
        rutes: null,
      },
      karyawan_id: null,
      teritory_id: [],
      sales: [],
      driver_id: [],
      kendaraan_id: [],
      perPage: 10,
      pageOptions: [10, 30, 50, 100],
      totalRows: 0,
      currentPage: 1,
      filter: "",
      searchDebounce: null,
      fields: [
        { key: "no", label: "No" },
        { key: "teritori", label: "Teritori" },
        { key: "info_sales", label: "Info Sales" },
        { key: "rute_sales", label: "Rute Sales" },
        { key: "keterangan", label: "Keterangan" },
        { key: "actions", label: "Aksi" },
      ],
      items: [],
      rutes: [],
      loading: false,
      saving: false,
    };
  },
  watch: {
    perPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getData();
    },
    currentPage() {
      this.getData();
    },
    filter() {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }
      this.searchDebounce = setTimeout(() => {
        this.applySearch();
      }, 350);
    },
  },
  async mounted() {
    await this.getData();
    this.getRutes();
    this.getDataDriver();
    this.getDataSales();
    this.getDataTeritori();
    this.getDataKendaraan();
  },
  beforeDestroy() {
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
  },
  methods: {
    optionLabel(...parts) {
      return parts
        .map((part) => {
          if (part == null || part === "null" || part === "undefined") return "";
          return String(part).trim();
        })
        .filter((part) => part !== "")
        .join(" - ");
    },
    applySearch() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getData();
    },
    clearSearch() {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }
      this.filter = "";
      this.applySearch();
    },
    async getRutes() {
      const rutes = await this.$store.dispatch("rute/getData", {
        order: "desc",
      });
      this.rutes = rutes.map((item) => ({
        value: item.id,
        text: this.optionLabel(item.nama_rute) || "",
      }));
    },
    add() {
      this.id = null;
      this.activeAction = "tambah";
      this.resetForm();
      this.showModal = true;
      this.showModalEdit = false;
    },
    remove(item) {
      this.$swal({
        title: "Anda yakin?",
        text: `Data gudang ini akan dihapus`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          item.fungsi = 1; // soft delete
          this.$store
            .dispatch("gudang/save", [item])
            .then(async () => {
              await this.getData();
              this.getDataSales();
              this.pesanBerhasilHapus();
            })
            .catch((e) => {
              this.pesanGagalHapus();
              this.displayError(e);
              return false;
            });
        }
      });
    },
    resetForm() {
      this.id = null;
      this.activeAction = "tambah";
      this.form = {
        nama_gudang: "-",
        teritory_id: 0,
        jenis: 2,
        kendaraan_id: null,
        karyawan_id: null,
        driver_id: null,
        keterangan: "",
        alamat: "",
        rutes: null,
      };
      this.selectedRutes = [];
      this.myRutes = [];
    },
    buildGudangPayload() {
      const isEdit = !!this.id;
      const payload = {
        nama_gudang: this.form.nama_gudang,
        teritory_id: this.form.teritory_id,
        jenis: this.form.jenis != null ? this.form.jenis : 2,
        kendaraan_id: this.form.kendaraan_id,
        karyawan_id: this.form.karyawan_id,
        driver_id: this.form.driver_id,
        keterangan: this.form.keterangan,
        alamat: this.form.alamat,
      };
      // Create must never send id (avoids leak after edit → create again)
      if (isEdit) {
        payload.id = this.id;
      }
      return payload;
    },
    buildRutePayloads(salesId) {
      const isEdit = !!this.id;
      if (!this.selectedRutes || this.selectedRutes.length < 1) {
        return { save: [], remove: [] };
      }

      const save = this.selectedRutes.map((rute) => {
        const rutePayload = {
          rute_id: rute.value,
          sales_id: salesId,
        };
        // Only keep rute-sales row id when updating existing assignment
        if (isEdit && rute.id) {
          rutePayload.id = rute.id;
        }
        return rutePayload;
      });

      const remove = [];
      if (isEdit && this.myRutes && this.myRutes.length > 0) {
        this.myRutes.forEach((rute) => {
          const stillSelected = this.selectedRutes.find(
            (item) => item.value == rute.value
          );
          if (!stillSelected) {
            remove.push({
              id: rute.id,
              fungsi: 2,
              rute_id: rute.value,
              sales_id: salesId,
            });
          }
        });
      }

      return { save, remove };
    },
    submit() {
      if (this.saving) return false;
      if (this.form.nama_gudang == null || this.form.nama_gudang == "") {
        this.pesanGagalSimpan();
        return false;
      }

      const payload = this.buildGudangPayload();
      this.saving = true;
      this.$store
        .dispatch("gudang/save", [payload])
        .then(async () => {
          const { save, remove } = this.buildRutePayloads(
            payload.karyawan_id
          );

          if (save.length > 0) {
            await this.$store.dispatch("rute/saveMyData", save);
          }
          if (remove.length > 0) {
            await this.$store.dispatch("rute/saveMyData", remove);
          }

          await this.getData();
          this.pesanBerhasilSimpan();
          this.resetForm();
          this.getDataSales();
          this.showModal = false;
          this.showModalEdit = false;
        })
        .catch((e) => {
          this.displayError(e);
          return false;
        })
        .finally(() => {
          this.saving = false;
        });
    },
    async edit(item) {
      this.selectedRutes = [];
      this.myRutes = [];
      this.id = item.id;
      this.activeAction = "ubah";
      // Copy fields only — do not bind form to list row reference
      this.form = {
        nama_gudang: item.nama_gudang || "-",
        teritory_id: item.teritori
          ? item.teritori.id
          : item.teritory_id || 0,
        jenis: item.jenis != null ? item.jenis : 2,
        kendaraan_id: item.kendaraan
          ? item.kendaraan.id
          : item.kendaraan_id || null,
        karyawan_id: item.karyawan
          ? item.karyawan.id
          : item.karyawan_id || null,
        driver_id: item.driver ? item.driver.id : item.driver_id || null,
        keterangan: item.keterangan || "",
        alamat: item.alamat || "",
        rutes: null,
      };
      this.showModal = true;

      const salesId = this.form.karyawan_id;
      const rutes = await this.$store.dispatch("rute/getMyData", {
        sales_id: salesId,
      });
      if (rutes && rutes.length > 0) {
        const selectedRutes = rutes.map((row) => ({
          id: row.id,
          value: row.rute_id,
          text: this.optionLabel(row.rute ? row.rute.nama_rute : null) || "",
        }));

        this.selectedRutes = selectedRutes;
        this.myRutes = selectedRutes;
      }
    },
    pesanBerhasilSimpan() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "CheckIcon",
            text: "Berhasil menyimpan data",
            variant: "success",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },
    pesanGagalSimpan() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "CheckIcon",
            text: "Gagal menyimpan data, harap cek kembali data yang diisi",
            variant: "warning",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },
    pesanBerhasilHapus() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "CheckIcon",
            text: "Berhasil menghapus data",
            variant: "success",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },
    pesanGagalHapus() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "CheckIcon",
            text: "Gagal menghapus data, harap cek kembali data yang diisi",
            variant: "warning",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },
    getData() {
      const params = {
        jenis: 2,
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      };
      if (this.filter && String(this.filter).trim() !== "") {
        params.search = String(this.filter).trim();
      }

      this.loading = true;
      return this.$store
        .dispatch("gudang/getData", params)
        .then((result) => {
          this.items = Array.isArray(result) ? result : [];
          this.totalRows =
            typeof result.total !== "undefined"
              ? Number(result.total)
              : this.items.length;
        })
        .catch((e) => {
          console.error(e);
          this.displayError(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDataTeritori() {
      this.$store
        .dispatch("teritori/getData", {})
        .then(() => {
          const ter = JSON.parse(
            JSON.stringify(this.$store.state.teritori.datas)
          );
          ter.map((item) => {
            item.value = item.id;
            item.text = this.optionLabel(
              item.nama_teritori,
              item.keterangan
            );
          });
          this.teritory_id = ter;
        })
        .catch((e) => console.error(e));
    },
    getDataKendaraan() {
      this.$store
        .dispatch("kendaraan/getData", {})
        .then(() => {
          const ken = JSON.parse(
            JSON.stringify(this.$store.state.kendaraan.datas)
          );
          ken.map((item) => {
            item.value = item.id;
            item.text = this.optionLabel(
              item.nama_kendaraan,
              item.plat_nomer
            );
          });
          this.kendaraan_id = ken;
        })
        .catch((e) => console.error(e));
    },
    getDataSales() {
      this.$store.dispatch("karyawan/getData", {}).then(() => {
        const sales = JSON.parse(
          JSON.stringify(this.$store.state.karyawan.datas)
        );
        sales.map((item) => {
          item.value = item.id;
          item.text = this.optionLabel(item.nama_lengkap);
        });
        this.karyawan_id = sales;
      });
    },
    getDataDriver() {
      this.$store.dispatch("karyawan/getData", {}).then(() => {
        const dri = JSON.parse(
          JSON.stringify(this.$store.state.karyawan.datas)
        );
        dri.map((item) => {
          item.value = item.id;
          item.text = this.optionLabel(item.nama_lengkap);
        });
        this.driver_id = dri;
      });
    },
  },
};
</script>
